import {get} from 'lodash';
import BaseService from '../../middleware/BaseService';

const USERSETTINGS_ENDPOINT = '/user/{userId}/setting';
const NOTIFICATION_SUBSCRIPTION_ENDPOINT = '/alerts/subscription';
const EVENT_VIDEO_ALERTS_TYPE = 'EVENT_VIDEO_ALERTS';

class UserSettingsService extends BaseService {
  prefix = USERSETTINGS_ENDPOINT;

  async getSettings(userId) {
    if (userId) {
      const response = await this.search({}, USERSETTINGS_ENDPOINT.replace('{userId}', userId));
      return response;
    }
    return {};
  }

  async updateSettings(userId, settings) {
    if (userId && settings) {
      const response = await this.post(settings, USERSETTINGS_ENDPOINT.replace('{userId}', userId));
      return get(response, 'data.settings', {});
    }
    return {};
  }

  async getNotifications() {
    const resp = await this.search({videoAlerts: true}, NOTIFICATION_SUBSCRIPTION_ENDPOINT);
    const alertNotifications = resp.data.filter(sub => get(sub, '_source.type', '') === EVENT_VIDEO_ALERTS_TYPE);

    if (!alertNotifications) {
      return [];
    }

    return alertNotifications;
  }

  async registerNotification(email) {
    const subscriptionConfig = {
      method: {
        type: 'EMAIL',
        value: email
      },
      type: 'EVENT_VIDEO_ALERTS'
    };

    const resp = await this.post(subscriptionConfig, NOTIFICATION_SUBSCRIPTION_ENDPOINT);

    return resp;
  }

  async disableNotification() {
    const notificationId = await this.getNotifications();
    return this.api.remove(NOTIFICATION_SUBSCRIPTION_ENDPOINT, {
      id: notificationId
    });
  }
}

export default new UserSettingsService();
